/**
 * Auth store (Zustand).
 *
 * Wraps localStorage token state with reactive subscribers.
 * The TanStack Query `me()` query is the source of truth for user data;
 * this store only tracks whether we have a token.
 */

import { create } from "zustand";
import {
  getAccessToken,
  setAccessToken,
  clearAccessToken,
  isAuthenticated,
} from "@/lib/auth";

interface AuthState {
  isSignedIn: boolean;
  signIn: (token: string) => void;
  signOut: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isSignedIn: isAuthenticated(),

  signIn: (token: string) => {
    setAccessToken(token);
    set({ isSignedIn: true });
  },

  signOut: () => {
    clearAccessToken();
    set({ isSignedIn: false });
  },
}));

// Allow external code (e.g., API layer) to read auth state without hooks
export { getAccessToken, isAuthenticated };
